import { itemStorageProvider } from "../../../lib/item-storage";

export const patientAuthToken = itemStorageProvider({
  storage: localStorage,
  key: "PATIENT_AUTH_TOKEN",
});
